import { Flex, GridItem, SimpleGrid, Stack, Text } from "@chakra-ui/react";
import React from "react";
import WhoWeServeItem from "../../molecules/WhoWeServeItem";

const WhoWeServeSection = ({
  whoWeServeMainTitle,
  whoWeServeMainDescription,
  whoWeServeItems,
  icon,
}: any) => {
  return (
    <Stack
      alignItems="center"
      justifyContent="center"
      gap={0}
      py={{ base: 10, md: 20 }}
      maxW="1280px"
      mx="auto"
      px={{ base: 4, "2xl": 0 }}
    >
      <Text
        className="light-text"
        fontSize="48px"
        lineHeight="100%"
        textAlign="center"
        pb={5}
        as="h2"
      >
        {whoWeServeMainTitle}
      </Text>
      <Text
        textAlign="center"
        color="#6A7471"
        fontSize="18px"
        className="regular-text"
        pb={10}
        dangerouslySetInnerHTML={{
          __html: whoWeServeMainDescription,
        }}
      ></Text>
      <Flex
        w="100%"
        justifyContent="center"
        alignItems="flex-start"
        direction={{ base: "column", md: "row" }}
        wrap="wrap"
        gap={10}
      >
        {whoWeServeItems?.map((item: any, index: any) => {
          return (
            <WhoWeServeItem
              key={index}
              title={item.whoWeServeItemTitle}
              description={item.whoWeServeItemDescription}
              iconName={item.icon?.node?.sourceUrl}
            />
          );
        })}
      </Flex>
    </Stack>
  );
};

export default WhoWeServeSection;
